"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.APP = exports.PUBLIC = void 0;
var PUBLIC = 'PUBLIC';
exports.PUBLIC = PUBLIC;
var APP = 'APP';
exports.APP = APP;


//////////////////
// WEBPACK FOOTER
// ./js/constants/AuthType.js
// module id = 300
// module chunks = 5 6 7